import { useLanguage } from '@/i18n/language-context';
import { SiteShell } from './site-shell';
import { Section } from './ui/layout';
import { LoadingState } from './ui/loading';

/** Public loading never depends on browser payment capabilities or donor identity. */
export function PageLoading(): JSX.Element {
  const { t } = useLanguage();
  return (
    <SiteShell>
      <main id="main-content" tabIndex={-1} className="giving-main ui-stack">
        <Section surface="card">
          <LoadingState label={t.loading} kind="summary" count={1} />
        </Section>
      </main>
    </SiteShell>
  );
}
